import React from 'react';
import Loader from '../Loader/Loader';    
import {Button} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const LoaderButton = (props:any) => {
  return (
      <React.Fragment>
        <Button
            onClick={props.onClick}
            disabled={props.isLoading}
            type={props.type}
            className="btn btn-blue">
                <FormattedMessage id={props.text} />
                {props.isLoading ? <Loader/> : null}
        </Button>
      </React.Fragment>
    );
}

export default LoaderButton


